import React from 'react';
import Box from '@material-ui/core/Box';

export interface TabPanelProps {
  selectedValue: number | string;
  value: number | string;
}

export class TabPanel extends React.Component<TabPanelProps, any> {

  constructor(props) {
    super(props);
  }

  render() {
    const {selectedValue, value, children} = this.props;

    return (
        <div
            role="tabpanel"
            hidden={selectedValue !== value}
        >
          {selectedValue === value && (
              <Box p={3}>
                {children}
              </Box>
          )}
        </div>
    );
  }
}